(function() {
  var Controller, Handler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  Handler = App.loadClass('core::Handler');

  exports.AddController = (function(superClass) {
    extend(AddController, superClass);

    function AddController(scope, transitions, data, legacy, state, userSelection, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.legacy = legacy;
      this.state = state;
      this.userSelection = userSelection;
      this.ngModal = ngModal;
      this.drawMaps = bind(this.drawMaps, this);
      this.uploadMaps = bind(this.uploadMaps, this);
      this.mapsToggle = bind(this.mapsToggle, this);
      this.addDataType = bind(this.addDataType, this);
      this.launchDrawHandler = bind(this.launchDrawHandler, this);
      this.launchLegacyForm = bind(this.launchLegacyForm, this);
      this.launchForm = bind(this.launchForm, this);
      this.loadScopeData = bind(this.loadScopeData, this);
      this.destroyAllSubHandlers = bind(this.destroyAllSubHandlers, this);
      AddController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.show_fullpage = false;
      this.scope.ngModalLauncherOptions = {
        resolve: {
          mode: 'Add'
        },
        ngbModalOptions: {
          size: 'lg',
          windowClass: 'extra-wide-form'
        }
      };
      if (this.state.params.fromDraw === 'true') {
        this.scope.selected_options.year = this.userSelection.getYear();
        this.scope.selected_options.field = this.userSelection.getField();
        this.scope.ngModalLauncherOptions.resolve.selectedField = this.scope.selected_options.field;
        this.scope.ngModalLauncherOptions.resolve.year = this.scope.selected_options.year;
      }
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          if (_this.state.current.name !== 'grower.data-define') {
            _this.legacy.destroyAllSubHandlers();
          }
          return _this.baseHandler.destroyAllSubHandlers();
        };
      })(this));
      this.scope.$watch("selected_options.field", (function(_this) {
        return function() {
          var ref;
          if (((ref = _this.scope.selected_options) != null ? ref.field : void 0) != null) {
            _this.scope.ngModalLauncherOptions.resolve.fieldId = _this.scope.selected_options.field.field_id;
            return _this.data.loadFieldBoundary(_this.scope.selected_options.field.field_id);
          }
        };
      })(this));
      this.scope.$watch("selected_options.year", (function(_this) {
        return function() {
          if (_this.scope.selected_options.year) {
            return _this.scope.ngModalLauncherOptions.resolve.year = _this.scope.selected_options.year;
          }
        };
      })(this));
      this.baseHandler = new Handler();
      this.baseHandler.init();
      this.scope.years = this.data.getSidebarYears();
      this.loadScopeData(this.data.getSidebarFields(), 'fields');
      this.scope.selected_options = this.scope.$parent.selected_options;
      this.scope.selected_options.operation = null;
      this.scope.operations = this.data.getOperations();
      this.scope.add_data_type = '';
      this.scope.add_form_type = 'plan';
      this.scope.$watch('add_form_type', (function(_this) {
        return function(type) {
          _this.scope.form_type_pretty = _.upperFirst(type);
          return _this.scope.ngModalLauncherOptions.resolve.type = _this.scope.form_type_pretty;
        };
      })(this));
      this.scope.selectedMapType = false;
      this.scope.uploadingMaps = false;
      this.scope.drawingMaps = false;
      this.scope.addDataType = this.addDataType;
      this.scope.launchForm = this.launchForm;
      this.scope.launchLegacyForm = this.launchLegacyForm;
      this.scope.launchDrawHandler = this.launchDrawHandler;
      this.scope.destroyAllSubHandlers = this.destroyAllSubHandlers;
      this.scope.uploadMaps = this.uploadMaps;
      this.scope.drawMaps = this.drawMaps;
      if (this.state.includes('grower.data.add.upload')) {
        this.scope.add_data_type = 'maps';
        this.mapsToggle('uploading');
      }
      if (this.state.includes('grower.data.add.draw')) {
        this.scope.add_data_type = 'maps';
        this.mapsToggle('drawing');
      }
      this.scope.$on('app:safelinked', (function(_this) {
        return function() {
          _this.scope.$parent.selected_options.field = null;
          _this.scope.selected_options.field = null;
          _this.scope.add_data_type = '';
          _this.scope.add_form_type = 'plan';
          _this.scope.selected_options.operation = null;
          _this.loadScopeData(_this.data.getSidebarYears(), 'years');
          _this.loadScopeData(_this.data.getAllYears(), 'all_years');
          return _this.loadScopeData(_this.data.getSidebarFields(), 'fields');
        };
      })(this));
    }

    AddController.prototype.destroyAllSubHandlers = function() {
      return this.legacy.destroyAllSubHandlers();
    };

    AddController.prototype.loadScopeData = function(promise, key) {
      promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope[key] = response.data.data;
          }
        };
      })(this));
      return promise;
    };

    AddController.prototype.launchForm = function(form, type) {
      var opts, params;
      if (type == null) {
        type = null;
      }
      opts = this.scope.selected_options;
      params = {
        year: opts.year,
        field_id: opts.field.field_id,
        is_ingredion_field: (opts.field.external_name != null) && opts.field.external_name === 'Ingredion' && opts.field.external_permission ? true : false
      };
      if (type != null) {
        params.tab = type;
      }
      return this.state.go("grower.data.add." + form, params);
    };

    AddController.prototype.launchLegacyForm = function(form) {
      if (form === 'Ears, Rows, and Length') {
        return this.ngModal.openERLDialog(this.scope.selected_options.field.field_id, this.scope.selected_options.year, 'Add').modalRef.result["catch"](_.noop);
      } else if (form === 'Harvest Load') {
        return this.ngModal.openHarvestLoadDialog(this.scope.selected_options.field.field_id, this.scope.selected_options.year, 'Add').modalRef.result["catch"](_.noop);
      } else if (form === 'Stand Count') {
        return this.ngModal.openStandCountDialog(this.scope.selected_options.field.field_id, this.scope.selected_options.year, 'Add').modalRef.result["catch"](_.noop);
      } else {
        this.scope.postOps = {
          fields_id: this.scope.selected_options.field.field_id,
          field: this.scope.selected_options.field.field_name,
          has_edit: true,
          id: null,
          layer_id: null,
          year: this.scope.selected_options.year
        };
        return this.legacy.addLayer(form, this.scope.postOps);
      }
    };

    AddController.prototype.launchDrawHandler = function() {
      return this.state.go('grower.data-define', {
        field_id: this.scope.selected_options.field.field_id,
        year: this.scope.selected_options.year
      });
    };

    AddController.prototype.addDataType = function(type) {
      if (type !== this.scope.add_data_type) {
        this.state.go('grower.data.add');
      }
      return this.scope.add_data_type = type;
    };

    AddController.prototype.mapsToggle = function(selection) {
      if (selection === 'uploading') {
        this.scope.uploadingMaps = true;
        this.scope.drawingMaps = false;
        return this.scope.selectedMapType = true;
      } else if (selection === 'drawing') {
        this.scope.drawingMaps = true;
        this.scope.uploadingMaps = false;
        return this.scope.selectedMapType = true;
      } else {

      }
    };

    AddController.prototype.uploadMaps = function() {
      this.state.go('grower.data.add.upload');
      return this.mapsToggle('uploading');
    };

    AddController.prototype.drawMaps = function() {
      this.state.go('grower.data.add.draw');
      return this.mapsToggle('drawing');
    };

    return AddController;

  })(Controller);

}).call(this);
